import React, { useState } from "react";
import Button from "@mui/material/Button";
import httpClient from "../../api/httpClient";
import Loading from "../specific/Loading";
import { getApimKey } from "../../api/httpHeaders";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* D O W N L O A D */
import { CSVLink, CSVDownload } from "react-csv";

//import ForecastDataSet from "../data/ForecastDataSet"

import ForecastDiarizadoResponse from "../classes/ForecastDiarizadoResponse";

import axios from "axios";
import PageHelper from "../../helper/pageHelper";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

interface props {
  endpoint: string;
  apiName?: string;
}

const FileUpload = (params: props) => {
  const { t } = useTranslation();
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | undefined>();
  const [myResult, setMyResult] = useState("");
  const [myUrl, setMyUrl] = useState(params.endpoint);
  const [showLoading, setShowLoading] = useState(false);

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const handleSubmission = () => {
    if (!selectedFile) {
      alert(t("common.fileUpload.selectFileFirst") || "Selecione um arquivo primeiro");
      return;
    }

    setShowLoading(true);
    var server = new httpClient(params.apiName ?? "Planejamento").baseURL;
    var _url: string = myUrl;
    const formData = new FormData();
    
    formData.append("data", selectedFile, selectedFile.name);
  
    const headers: Record<string, string> = {
      "Access-Control-Allow-Origin": "*",
      authorization: `Bearer ${localStorage.getItem("Token")}`,
    };

    // Adicionar Ocp-Apim-Subscription-Key apenas em produção
    const apimKey = getApimKey();
    if (apimKey) {
      headers["Ocp-Apim-Subscription-Key"] = apimKey;
    }

    axios
      .post(`${server}${_url}`, formData, {
        headers,
      })
      .then((response) => response.data)
      .then((result) => {
        setMyResult(JSON.stringify(result));
        console.log("Success:", result);
        setShowLoading(false);
        (params as any).setCsvFoiEnviado({
          wasUpdated: true,
          isSuccess: !result.includes("Inválido"),
          details: result,
        });
      })
      .catch((error) => {
        setShowLoading(false);
        (params as any).setCsvFoiEnviado({
          wasUpdated: true,
          isSuccess: false,
          details: error.response?.data || error.message,
        });
      });
  };

  return (
    <Box sx={{ width: "460px", height: "250px" }}>
      {isSelected ? (   
        <div>
          <p>
            {t("common.fileUpload.resultProcessingFile")}
            <strong>{selectedFile?.name}</strong>
          </p>
          <p>
            {t("common.fileUpload.fileSize")}
            <strong>{selectedFile?.size}</strong>
          </p>
          <p>
            {t("common.fileUpload.lastModifiedDate")}
            <strong>{selectedFile?.lastModified ? format(selectedFile?.lastModified, "dd/MM/yyyy") : ""}</strong>
          </p>
          {showLoading ? (
            <Loading />
          ) : (
            <Button
              className="button"
              variant="outlined"
              onClick={handleSubmission}
            >
              {t("common.fileUpload.submit")}
            </Button>
          )}
        </div>
      ) : (
        <>
          <p>{t("common.fileUpload.selectFileForDetails")}</p>
          <div>
            <label className="button" htmlFor="upload">
              {t("common.fileUpload.uploadFile")}
            </label>
            {"    "}
            <input
              id="upload"
              type="file"
              name="file"
              onChange={changeHandler}
            />
          </div>
        </>
      )}
    </Box>
  );
};

export default FileUpload;
